export default "__VITE_ASSET__DNr1D$xZ__"